function isGerman() {
  const language = document.getElementById('flagheader').getElementsByTagName('a')[0].text;
  return (language.indexOf('Deutsch') !== -1);
}

function formatAmount(amount) {
  // Wrap value in money signs.
  let displayValue = `€${amount},-`;
  if (isGerman()) {
    displayValue = `${amount},- €`;
  }

  return displayValue;
}

export default { isGerman, formatAmount };
